export default "__VITE_ASSET__BY792nyZ__"